import { useEffect, useMemo, useRef, useState } from "react"
import { MaterialReactTable } from "material-react-table"
import { Box } from "@mui/material"
import { TableHeading, TableWrapperPaper } from "./DashboardTables"
import { useSelector } from "react-redux"
import SortIcon from "@mui/icons-material/Sort"
import { colors } from "../../../../styles/commonStyles"
import CommonTable from "./CommonTable"

export type User = {
  metricName: string
  mtdBudget: number
  mtdActual: number
  variance: number
}
export const OpportunityTable = ({ loading }: { loading?: boolean }) => {
  const activeOpportunitySummary = useSelector((state: any) => {
    return state.dashboard?.opportunityData?.activeOpportunitySummary
  })

  const activeOpportunity = useSelector((state: any) => {
    return state.dashboard?.opportunityData?.activeOpportunity
  })

  const activeOpportunitiesColumn = useMemo<any[]>(
    () => [
      {
        accessorKey: "name",
        header: "Practice",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.name}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "opportunity",
        header: "Opportunity",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.opportunity}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "start_date",
        header: "Start Date",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.start_date || "-"}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "end_date",
        header: "End Date",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => (
          <Box>{renderedCellValue ? `${renderedCellValue}` : "-"}</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "target_column",
        header: "Target KPI",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => (
          <Box>{renderedCellValue.replaceAll("_", " ")}</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "target_value",
        header: "Start Value",
        enableSorting: true,
        // Cell: ({ renderedCellValue }: any) => (
        //   <Box>
        //     {renderedCellValue}
        //     {activeOpportunitySummary[0]?.target_column_data_type}
        //   </Box>
        // ),
        Cell: ({ row }: any) => (
          <Box>
            {row.original.target_column_data_type == "$"
              ? row.original.target_column_data_type +
                " " +
                row.original.target_value
              : row.original.target_column_data_type == "%"
              ? row.original.target_value +
                " " +
                row.original.target_column_data_type
              : row.original.target_value}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "target_current_value",
        header: "Current Value",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            {row.original.target_column_data_type == "$"
              ? row.original.target_column_data_type +
                " " +
                row.original.target_current_value
              : row.original.target_column_data_type == "%"
              ? row.original.target_current_value +
                " " +
                row.original.target_column_data_type
              : row.original.target_current_value}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },

      {
        accessorKey: "percent_difference",
        header: "% Difference",
        enableSorting: true,
        enableEditing: false,
        Cell: ({ renderedCellValue }: any) => <Box>{renderedCellValue} %</Box>,
        muiTableBodyCellProps: ({ cell }: any) => ({
          sx: {
            padding: "0px 2%",
            "& div": {
              display: "flex",
              margin: "auto",
              justifyContent: "center",
              padding: "5%",

              border:
                cell?.row?.original?.percent_difference_highlighting != null
                  ? "1px solid #FFFFFF"
                  : null,

              backgroundColor:
                cell?.row?.original?.percent_difference_highlighting === "green"
                  ? colors.primaryGreen
                  : cell?.row?.original?.percent_difference_highlighting ===
                    "red"
                  ? colors.primaryRed
                  : "#FFFFFF",
              color:
                cell?.row?.original?.percent_difference_highlighting == null
                  ? colors.primaryBlack
                  : colors.primaryWhite,
            },
          },
        }),
      },
    ],
    [],
  )

  const activeOpportunitiesSummaryColumn = useMemo<any[]>(
    () => [
      {
        accessorKey: "name",
        header: "Practice",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.name}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "total_count",
        header: "# of Opportunities",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.total_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "green_count",
        header: "Green",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.green_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "red_count",
        header: "Red",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.red_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
    ],
    [],
  )

  return (
    <Box>
      <TableWrapperPaper
        sx={{
          width: "fit-content",
          m: "2% 1px 2% 2%",
        }}
      >
        <TableHeading>Active Opportunity Summary</TableHeading>
        <CommonTable
          data={activeOpportunitySummary || []}
          column={activeOpportunitiesSummaryColumn}
          isloading={loading}
        />
      </TableWrapperPaper>

      <TableWrapperPaper
        sx={{
          m: "2% auto auto auto",
        }}
      >
        <TableHeading>Active Opportunities</TableHeading>
        <CommonTable
          data={activeOpportunity || []}
          column={activeOpportunitiesColumn}
          isloading={loading}
        />
      </TableWrapperPaper>
    </Box>
  )
}

export default OpportunityTable
